<template>
  <v-dialog v-model="show" width="700" persistent>
    <v-card>
      <v-card-title class="headline" primary-title>
        <div class="d-flex flex-fill">
          <div>
            <small>{{ title ? title : commonTitle }}</small>
          </div>
          <div class="ml-auto cursor" @click="close()">
            <v-icon style="color:#0c0c0c">mdi-close</v-icon>
          </div>
        </div>
      </v-card-title>

      <v-card-text class="pt-2">
        <div class="d-flex flex-column flex-sm-row justify-space-between align-center align-sm-start">
          <div class="d-flex flex-column">
            <div style="font-size:16px;" :class="{'text-center': $vuetify.breakpoint.xsOnly}">{{ desc }}</div>
            <div class="btns-group mt-4">
              <a class="my-2" :class="$vuetify.breakpoint.smAndUp ? 'mr-2' : 'mx-2'" v-for="(value, name, index) in btnList" :href="value.path" target="_blank" :key="index">
                <img :src="value.icon" alt />
              </a>
            </div>
            <div class="btns-group">
              <a class="my-2" :class="$vuetify.breakpoint.smAndUp ? 'mr-2' : 'mx-2'" v-for="(value, name, index) in btnList2" :href="value.path" target="_blank" :key="index">
                <img :src="value.icon" alt />
              </a>
            </div>
          </div>
          <div class="" style="text-align:center; margin:auto 0;">
            <v-progress-circular style="width:160px;" v-if="!qrString" indeterminate size="64"></v-progress-circular>
            <QrCode v-else :text="qrString" />
          </div>
        </div>
        <div v-if="pkgType === 'REGISTER'" class="mt-10 mb-2 text-left">
          <v-checkbox v-model="withKyc" :label="$t('max.register.iAgree')" type="checkbox"></v-checkbox>
        </div>
        <div class="row bottom-section">
          <div class="col-12 col-sm-4 text-center">
            <img class="img-step" :src="imgStep1" />
            <div class="mb-2">{{ $t('max.register.step1') }}</div>
          </div>
          <div class="col-12 col-sm-4 text-center">
            <img class="img-step" :src="imgStep2" />
            <div class="mb-2">{{ $t('max.register.step2') }}</div>
          </div>
          <div class="col-12 col-sm-4 text-center">
            <img class="img-step" :src="imgStep3" />
            <div class="mb-2">{{ $t('max.register.step3') }}</div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import QrCode from '@/components/QrCode/QrCode';
import { mutationTypes } from '@/store/mutation-types';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { MXWRegister } from 'mxw-register-sdk-web';
import { maxRegisterApi } from '@/api/maxRegisterApi';
import { simpleCookie } from '@/common/js/simpleCookie';

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    pkgType: {
      type: String,
      required: true
    }
  },
  components: {
    QrCode
  },
  data() {
    return {
      maxRegisterModalShow: false,
      qrString: '',
      withKyc: false,
      isConnected: false,
      mxwRegister: null,
      mxwRegisterUrl: window.env.mxwRegister.url,
      mxwRegisterPath: window.env.mxwRegister.path,
      imgStep1: require('@/assets/images/account/max-register-step-1.png'),
      imgStep2: require('@/assets/images/account/max-register-step-2.png'),
      imgStep3: require('@/assets/images/account/max-register-step-3.png'),
      btnList: {
        max_ios_store: { icon: require('@/assets/images/home/grx_ios_store.svg'), path: '' },
        max_android_store: { icon: require('@/assets/images/home/grx_android_store.svg'), path: '' }
      },
      btnList2: {
        max_ipa: { icon: require('@/assets/images/home/max_ios_ipa.png'), path: '' },
        max_apk: { icon: require('@/assets/images/home/max_android_apk.png'), path: '' }
      }
    };
  },
  watch: {
    // show: function(val) {
    // this.maxRegisterModalShow = this.show;
    // if (this.show && this.isConnected) {
    //   this.renderQrString();
    // }
    // },
    // maxRegisterModalShow: function(val) {
    //   this.$emit('update:show', val);
    // },
    isConnected: function(val) {
      if (this.show && this.isConnected) {
        this.renderQrString();
      }
    },
    withKyc: function(val) {
      this.renderQrString();
    }
  },
  computed: {
    ...mapGetters(['Getter_User_Info', 'getLoginPkgInfo', 'getRegisterPkgInfo', 'getPkgInfo'])
  },
  async created() {
    // As watch wouldn't be triggered on first load, change the maxRegisterModalShow here so that the bootstrap modal will show
    // this.maxRegisterModalShow = this.show;
    await this.getMxwPkgInfo_action();

    this.mxwRegister = new MXWRegister(this.getPkgInfo.id, this.mxwRegisterUrl, this.mxwRegisterPath);
    this.mxwRegister.init();
    this.mxwRegister.onConnect = connected => {
      if (connected) {
        this.isConnected = true;
        // console.log('Max register socket connected');
      }
    };
    this.mxwRegister.onSignOn = data => {
      if (!this.isUndefinedOrNullOrEmpty(data)) {
        this.loginWithMaxWallet(JSON.stringify(data));
      }
    };

    this.mxwRegister.onSignUp = data => {
      if (!this.isUndefinedOrNullOrEmpty(data)) {
        if (this.pkgType === 'REGISTER') {
          this.registerWithMaxWallet(JSON.stringify(data));
        } else if (this.pkgType === 'GET_KYC') {
          const submitData = {
            userId: this.Getter_User_Info.id,
            data: JSON.stringify(data)
          };
          this.performKycWithMaxWallet(submitData);
        } else if (this.pkgType === 'BIND') {
          this.bindMaxWallet(JSON.stringify(data));
        }
      }
    };

    this.mxwRegister.onError = error => {
      console.error('onError error', error);
    };
    this.assignEnvConfig();
  },
  beforeDestroy() {
    this.mxwRegister.disconnect();
  },
  methods: {
    ...mapActions(['GET_USERINFO_ACTION', 'getMxwPkgInfo_action']),
    ...mapMutations([
      mutationTypes.SET_USERNAME,
      mutationTypes.SET_TOKEN,
      mutationTypes.SET_EXPIRETIME,
      mutationTypes.SET_LASTUPDATETIME
    ]),

    assignEnvConfig() {
      this.btnList['max_ios_store'].path = 'https://apps.apple.com/app/id1456349663';
      this.btnList['max_android_store'].path = 'https://play.google.com/store/apps/details?id=com.maxonrow.wallet';
      this.btnList2['max_ipa'].path = window.env.maxWalletApp.ipa;
      this.btnList2['max_apk'].path = window.env.maxWalletApp.apk;
    },

    loginWithMaxWallet(data) {
      maxRegisterApi.loginWithMaxWallet(data).then(response => {
        this.processLoginSuccess(response.data);
        this.$router.replace({ name: 'home' });
      });
    },
    registerWithMaxWallet(data) {
      maxRegisterApi.registerWithMaxWallet(data).then(response => {
        this.processLoginSuccess(response.data);
        this.$router.replace({ name: 'home' });
      });
    },
    performKycWithMaxWallet(data) {
      maxRegisterApi.performKycWithMaxWallet(data).then(response => {
        if (!this.isUndefinedOrNullOrEmpty(response)) {
          this.$emit('update:show', false);
          this.GET_USERINFO_ACTION();
        }
      });
    },
    bindMaxWallet(data) {
      maxRegisterApi.bindMaxWallet(data).then(response => {
        if (!this.isUndefinedOrNullOrEmpty(response)) {
          this.$emit('update:show', false);
          this.GET_USERINFO_ACTION();
          this.successNotify(this.$t('success.bindMAXWallet'));
        }
      });
    },
    processLoginSuccess(data) {
      simpleCookie.setItem('isLogin', true);
      // 以秒为单位
      this.SET_LASTUPDATETIME(new Date().getTime() / 1000);
      // this.SET_EXPIRETIME(data.expire);
      this.SET_EXPIRETIME(new Date().getTime() + 100000);
      this.SET_TOKEN(data.accessToken);
      this.SET_USERNAME(data.userName);

      this.GET_USERINFO_ACTION();
      this.successNotify(this.$t('login.success'));
    },
    async renderQrString() {
      if (this.isEmpty(this.getPkgInfo)) {
        await this.getMxwPkgInfo_action();
      }
      console.log('this.mxwRegister.signOn()-->', this.mxwRegister.signOn());
      switch (this.pkgType) {
        case 'LOGIN':
          this.qrString = JSON.stringify(this.mxwRegister.signOn());
          break;
        case 'REGISTER':
          this.qrString = this.withKyc
            ? JSON.stringify(this.mxwRegister.signUp(this.getPkgInfo.rk))
            : JSON.stringify(this.mxwRegister.signUp(this.getPkgInfo.r));
          // r = register without kyc data, rk = register with kyc data, k: kyc only
          break;
        case 'GET_KYC':
          this.qrString = JSON.stringify(this.mxwRegister.signUp(this.getPkgInfo.k));
          break;
        case 'BIND':
          this.qrString = JSON.stringify(this.mxwRegister.signUp(this.getPkgInfo.r));
          break;
      }
    },
    close() {
      this.$emit('update:show', false);
    }
  }
};
</script>
<style lang="stylus" scoped>
@import './max-register-modal.styl'
</style>
